/* Purpose: A catching graphic with the company's name and slogan 
 * Props: page (str) --optional
 * Author: R. Markowitz (April 2025)
 * Dev Notes: As of now, only page = Home affects the graphics. 
 *              For any other page, do not send props or add scss
*/

import React from 'react';
import { Image } from 'react-bootstrap';

const SloganHeader = ({page}) => {
    const backgroundImage = require("../Images/background-low-contrast2.jpg")
    const windsorLogo = require("../Images/windsorLogoShort.png")
    if (!page){
        page = ""
    }else{
        page = "-" + page
    }
    return (
    <div>
        {/* <div style = {{backgroundImage: `url(${backgroundImage})`}} className={'slogan-header-background'+page}>
            <div className='slogan-header-border'>
                <p className='slogan-header-text1'>- Windsor Lending -</p>
                <p className='slogan-header-text2'>Building Possibilities. Funding Dreams.</p>
            </div>
        </div> */}
        <img src={windsorLogo} class="slogan-img" alt="Responsive image"></img>
    </div>
    )
}

export default SloganHeader;
